import React from "react";
import { FlipperVaultCardProps } from "../../../../../stories/common/flipper-vault-card";
import styles from "./index.module.scss";
import PREListing from "./pre-list";
import InfoTags from "../../../../../stories/common/flipper-vault-card/info-tags";
import { useNavigate, useSearchParams } from "react-router-dom";
import { InvestorEventsClicked } from "../../../../../utils/inv-exch-amplitude";

export default function AddressSection({
  account
}: {
  account: FlipperVaultCardProps;
}) {
  const [searchParams] = useSearchParams();
  const propertyId = searchParams.get("pid") || "";
  const propertySfid = searchParams.get("sfid") || "";
  const street = searchParams.get("street") || "";
  const city = searchParams.get("city") || "";
  const navigate = useNavigate();
  return (
    <div className={styles.addressSection}>
      <div className={styles.LeftSection}>
        <div className={styles.FlipperVaultCardInfo}>
          <InfoTags
            value={account?.totalPurchased || "N/A"}
            title="Total Purchase PRE's"
          />
          <InfoTags
            value={account?.totalPurchasedFT || "N/A"}
            title="Total Purchase FT"
          />
          <InfoTags value={account?.totalSold || "N/A"} title="Total Sold" />
          <InfoTags
            value={account?.totalFlips || "N/A"}
            title="Total Flipped"
          />
        </div>
        <div
          className={styles.viewBtn}
          onClick={() => {
            navigate(
              `/inv-activity?acctId=${account?.acctId}&name=${encodeURIComponent(account?.acctName || "")}&pid=${propertyId}&street=${encodeURIComponent(street)}&city=${encodeURIComponent(city)}`
            );
            InvestorEventsClicked({
              property_id: propertyId,
              property_sfid: propertySfid,
              investor_id: account?.acctId,
              investor_sfid: account?.acctSfid
            });
          }}
        >
          View Activity
        </div>
      </div>
      <div className={styles.RightSection}>
        <PREListing preData={account?.pre} />
      </div>
    </div>
  );
}
